import { ActivatedRoute } from '@angular/router';
import { EmployerDto } from './../../../service/dto';
import { Component, OnInit } from '@angular/core';
import { HttpEmployerService } from '../../../service/http-employer.service';

@Component({
  selector: 'app-employer-view',
  standalone: false,
  templateUrl: './employer-view.component.html',
  styleUrl: './employer-view.component.scss'
})
export class EmployerViewComponent implements OnInit {
	employer?: EmployerDto;
	loading = false;
	error?: string;
	hasDynamicProperties:boolean=false;

	constructor(private route: ActivatedRoute, private employerService: HttpEmployerService) { }

	ngOnInit(): void {
		const employerId = this.route.snapshot.paramMap.get('employerId');
		if (employerId) {
			this.loadEmployer(+employerId);
		} else {
			this.error = 'No employer ID provided in route.';
		}
	}

	private loadEmployer(id: number): void {
		this.loading = true;
		this.employerService.getFull(id).subscribe(result => {
			this.employer = result;
			this.hasDynamicProperties = Object.keys(this.employer.properties).length > 0;
			this.loading = false;
		});
	}
}
